<template>
  <div class="receiveCoupon">
    <el-tabs v-model="activeName" @tab-click="handleChangeTab">
          <el-tab-pane :label="'全部('+coupons.length+')'" name="coupons">
            <div class="couponList">
              <div class="clearfix sub-main" v-if="coupons.length > 0">
                <div class="couponItem active" v-for="(item, index) of coupons" :key="index">
                  <div class="couponItemTop">
                    <img src="../../../assets/images/indexLogo.png" alt="">
                    <span><i>￥</i>{{item.couponPrice}}</span>
                    <span>优惠券类型：{{item.ctype == "1"?"商品卷":"通用卷"}}</span>
                    <span>满{{item.useMinPrice}}元可用</span>
                    <span>有效期：{{item.startTime}}-{{item.endTime}}</span>
                    <div class="couponType">平台卷</div>
                  </div>
                  <div v-if="item.isUse == false" class="couponItemBot" @click="receive(item)">
                    领取
                  </div>
                  <div v-else class="couponItemBot" @click="receive(item,true)">
                    已领取
                  </div>
                </div>
              </div>
              <div class="noCoupon" v-else>
                  <img src="../../../../static/image/noorder@2x.png" alt="">
                  <p class="fs20 font-color-999">你还没有可领取的卷包哦～</p>
              </div>
             <el-pagination v-if="total>0" :current-page="page" :page-size="limit" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'>
             </el-pagination>
              </div>
            </el-tab-pane>
        </el-tabs>

  </div>
</template>

<script>
  import api from '@/api'
  import { listSearchMixin } from '@/config/mixin'
  import {mapGetters} from 'vuex'
  export default{
    name: 'receiveCoupon',
    mixins: [listSearchMixin],
    data(){
      return{
        coupons:[],
        activeName:"coupons",
        total:0,
        page:1,
        limit:10,

      }
    },
    computed: {
      ...mapGetters([
        'userInfo' // 用户信息
      ])
    },
    created() {
      this.getUnreceivedCouponList();
    },
    methods:{
      //获取可领取优惠券
      getUnreceivedCouponList(){
        let self = this
        var page = {
          "limit":this.limit,
          "page":this.page,
        }
        let params = {
          url: api.getUnreceivedCouponList +"?page="+this.page+"&limit="+this.limit,
          method: 'GET',
          page
        }
        self.sendReq(params, (res) => {
          console.log(res);
          this.coupons = res.data.list;
          this.total = res.data.total;
        })
      },
      //领取优惠券
      receive(item,flag){
        if(flag){
          this.$message.warning("您已领取过此优惠券");
          return false;
        }
        let self = this;
        let params = {
          url: api.receiveCoupon,
          method: "POST",
          data: {
            couponId: item.cid,
            id:item.id
          },
        };
        self.sendReq(params, (res) => {
          if (res.status == "200") {
            self.$message.success("领取成功");
            self.getUnreceivedCouponList();
          } else {
            this.$message.warning(res.msg);
          }
        });
      },
      handleChangeTab (tab, event) {
        // console.log(tab, event)
      },
      handleCurrentChange(val){
        this.page = val
        this.getUnreceivedCouponList();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .receiveCoupon {
    border: 1px solid #E5E5E5;
    min-height: 500px;
    >>> .el-tabs__nav-scroll {
      padding-left: 30px;
      .el-tabs__nav {
        height: 60px;
        line-height: 60px;
      }
    }
    >>> .el-tabs__content {
      padding:0 30px;
    }
    .couponList {
      margin-bottom: 30px;
      padding: 20px;
      .couponItem {
        width: 245px;
        border: 1px solid #EEEEEE;
        border-radius: 18px;
        overflow: hidden;
        margin:0 100px 50px 0;
        float: left;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .couponItemTop {
          background: #d7d7d7;
          color: #ffffff;
          padding: 20px;
          box-sizing: border-box;
          position: relative;
          img {
            opacity: 0.2;
            position: absolute;
            top: 40%;
          }
          .couponType {
            position: absolute;
            top: 1px;
            right: -33px;
            width: 100px;
            transform: rotate(45deg);
            background: #FFFFFF;
            color: #999999;
            text-align: center;
            height: 40px;
            line-height: 50px;
          }
          span {
            font-size: 12px;
            display: block;
            margin-bottom: 18px;
            cursor: pointer;
            i {
              margin-right: 5px;
              font-style: normal;
              font-size: 16px;
            }
          }
          span:nth-child(2) {
            font-size: 28px;
          }
          span:nth-child(4) {
            margin-bottom: 0;
          }
        }
        .couponItemBot {
          height: 40px;
          line-height: 40px;
          color: #999999;
          position: relative;
          text-align: center;
          background: #FFFFFF;
          cursor: pointer;
        }
      }
      .active {
        .couponItemTop {
          background: #fd5b5b;
          color: #ffffff;
          .couponType {
            background: #FFFFFF;
            color: #fd5b5b;
          }
        }
        .couponItemBot {
          background: #f3f3f3;
          color: #333333;
        }
      }
    }
    .noCoupon{
      text-align: center;
    }
  }
  .sub-main{
    min-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/views/userCenter/receiveCoupon/receiveCoupon.vue